// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BankWaypoint, BankWaypointT, verifyBankWaypoint } from "./bank-waypoint";
import { Waypoint, WaypointT, verifyWaypoint } from "./waypoint";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Group waypoint overlay item.
 */
export class GroupWaypoint implements flatbuffers.IUnpackableObject<GroupWaypointT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): GroupWaypoint {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsGroupWaypoint(bb: flatbuffers.ByteBuffer, obj?: GroupWaypoint): GroupWaypoint {
    return (obj || new GroupWaypoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsGroupWaypoint(
    bb: flatbuffers.ByteBuffer,
    obj?: GroupWaypoint,
  ): GroupWaypoint {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new GroupWaypoint()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  nickname(): string | null;
  nickname(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  nickname(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  x(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  y(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  backgroundColorHex(): string | null;
  backgroundColorHex(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  backgroundColorHex(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  backgroundOpacity(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  backgroundWidth(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  backgroundHeight(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  displayName(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  fontSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  fontColorHex(): string | null;
  fontColorHex(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fontColorHex(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  backgroundRotationDeg(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  nameRotationDeg(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  syncRotations(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  minX(): number {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  maxX(): number {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  minY(): number {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  maxY(): number {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  lifts(index: number, obj?: Waypoint): Waypoint | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? (obj || new Waypoint()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  liftsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  banks(index: number, obj?: BankWaypoint): BankWaypoint | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset
      ? (obj || new BankWaypoint()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  banksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startGroupWaypoint(builder: flatbuffers.Builder) {
    builder.startObject(20);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addNickname(builder: flatbuffers.Builder, nicknameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nicknameOffset, 0);
  }

  static addX(builder: flatbuffers.Builder, x: number) {
    builder.addFieldFloat64(2, x, 0.0);
  }

  static addY(builder: flatbuffers.Builder, y: number) {
    builder.addFieldFloat64(3, y, 0.0);
  }

  static addBackgroundColorHex(
    builder: flatbuffers.Builder,
    backgroundColorHexOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(4, backgroundColorHexOffset, 0);
  }

  static addBackgroundOpacity(builder: flatbuffers.Builder, backgroundOpacity: number) {
    builder.addFieldInt32(5, backgroundOpacity, 0);
  }

  static addBackgroundWidth(builder: flatbuffers.Builder, backgroundWidth: number) {
    builder.addFieldInt32(6, backgroundWidth, 0);
  }

  static addBackgroundHeight(builder: flatbuffers.Builder, backgroundHeight: number) {
    builder.addFieldInt32(7, backgroundHeight, 0);
  }

  static addDisplayName(builder: flatbuffers.Builder, displayName: boolean) {
    builder.addFieldInt8(8, +displayName, +false);
  }

  static addFontSize(builder: flatbuffers.Builder, fontSize: number) {
    builder.addFieldInt32(9, fontSize, 0);
  }

  static addFontColorHex(builder: flatbuffers.Builder, fontColorHexOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, fontColorHexOffset, 0);
  }

  static addBackgroundRotationDeg(builder: flatbuffers.Builder, backgroundRotationDeg: number) {
    builder.addFieldInt32(11, backgroundRotationDeg, 0);
  }

  static addNameRotationDeg(builder: flatbuffers.Builder, nameRotationDeg: number) {
    builder.addFieldInt32(12, nameRotationDeg, 0);
  }

  static addSyncRotations(builder: flatbuffers.Builder, syncRotations: boolean) {
    builder.addFieldInt8(13, +syncRotations, +true);
  }

  static addMinX(builder: flatbuffers.Builder, minX: number) {
    builder.addFieldFloat64(14, minX, 0.0);
  }

  static addMaxX(builder: flatbuffers.Builder, maxX: number) {
    builder.addFieldFloat64(15, maxX, 0.0);
  }

  static addMinY(builder: flatbuffers.Builder, minY: number) {
    builder.addFieldFloat64(16, minY, 0.0);
  }

  static addMaxY(builder: flatbuffers.Builder, maxY: number) {
    builder.addFieldFloat64(17, maxY, 0.0);
  }

  static addLifts(builder: flatbuffers.Builder, liftsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, liftsOffset, 0);
  }

  static createLiftsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLiftsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBanks(builder: flatbuffers.Builder, banksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, banksOffset, 0);
  }

  static createBanksVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBanksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endGroupWaypoint(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createGroupWaypoint(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    nicknameOffset: flatbuffers.Offset,
    x: number,
    y: number,
    backgroundColorHexOffset: flatbuffers.Offset,
    backgroundOpacity: number,
    backgroundWidth: number,
    backgroundHeight: number,
    displayName: boolean,
    fontSize: number,
    fontColorHexOffset: flatbuffers.Offset,
    backgroundRotationDeg: number,
    nameRotationDeg: number,
    syncRotations: boolean,
    minX: number,
    maxX: number,
    minY: number,
    maxY: number,
    liftsOffset: flatbuffers.Offset,
    banksOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    GroupWaypoint.startGroupWaypoint(builder);
    GroupWaypoint.addId(builder, idOffset);
    GroupWaypoint.addNickname(builder, nicknameOffset);
    GroupWaypoint.addX(builder, x);
    GroupWaypoint.addY(builder, y);
    GroupWaypoint.addBackgroundColorHex(builder, backgroundColorHexOffset);
    GroupWaypoint.addBackgroundOpacity(builder, backgroundOpacity);
    GroupWaypoint.addBackgroundWidth(builder, backgroundWidth);
    GroupWaypoint.addBackgroundHeight(builder, backgroundHeight);
    GroupWaypoint.addDisplayName(builder, displayName);
    GroupWaypoint.addFontSize(builder, fontSize);
    GroupWaypoint.addFontColorHex(builder, fontColorHexOffset);
    GroupWaypoint.addBackgroundRotationDeg(builder, backgroundRotationDeg);
    GroupWaypoint.addNameRotationDeg(builder, nameRotationDeg);
    GroupWaypoint.addSyncRotations(builder, syncRotations);
    GroupWaypoint.addMinX(builder, minX);
    GroupWaypoint.addMaxX(builder, maxX);
    GroupWaypoint.addMinY(builder, minY);
    GroupWaypoint.addMaxY(builder, maxY);
    GroupWaypoint.addLifts(builder, liftsOffset);
    GroupWaypoint.addBanks(builder, banksOffset);
    return GroupWaypoint.endGroupWaypoint(builder);
  }

  unpack(): GroupWaypointT {
    return new GroupWaypointT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.nickname(),
      this.x(),
      this.y(),
      this.backgroundColorHex(),
      this.backgroundOpacity(),
      this.backgroundWidth(),
      this.backgroundHeight(),
      this.displayName(),
      this.fontSize(),
      this.fontColorHex(),
      this.backgroundRotationDeg(),
      this.nameRotationDeg(),
      this.syncRotations(),
      this.minX(),
      this.maxX(),
      this.minY(),
      this.maxY(),
      this.bb!.createObjList<Waypoint, WaypointT>(this.lifts.bind(this), this.liftsLength()),
      this.bb!.createObjList<BankWaypoint, BankWaypointT>(
        this.banks.bind(this),
        this.banksLength(),
      ),
    );
  }

  unpackTo(_o: GroupWaypointT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.nickname = this.nickname();
    _o.x = this.x();
    _o.y = this.y();
    _o.backgroundColorHex = this.backgroundColorHex();
    _o.backgroundOpacity = this.backgroundOpacity();
    _o.backgroundWidth = this.backgroundWidth();
    _o.backgroundHeight = this.backgroundHeight();
    _o.displayName = this.displayName();
    _o.fontSize = this.fontSize();
    _o.fontColorHex = this.fontColorHex();
    _o.backgroundRotationDeg = this.backgroundRotationDeg();
    _o.nameRotationDeg = this.nameRotationDeg();
    _o.syncRotations = this.syncRotations();
    _o.minX = this.minX();
    _o.maxX = this.maxX();
    _o.minY = this.minY();
    _o.maxY = this.maxY();
    _o.lifts = this.bb!.createObjList<Waypoint, WaypointT>(
      this.lifts.bind(this),
      this.liftsLength(),
    );
    _o.banks = this.bb!.createObjList<BankWaypoint, BankWaypointT>(
      this.banks.bind(this),
      this.banksLength(),
    );
  }

  unpackFields(...fields: string[]): GroupWaypointT {
    const t = new GroupWaypointT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("nickname")) {
      t.nickname = this.nickname();
    }
    if (fieldSet.has("x")) {
      t.x = this.x();
    }
    if (fieldSet.has("y")) {
      t.y = this.y();
    }
    if (fieldSet.has("background_color_hex")) {
      t.backgroundColorHex = this.backgroundColorHex();
    }
    if (fieldSet.has("background_opacity")) {
      t.backgroundOpacity = this.backgroundOpacity();
    }
    if (fieldSet.has("background_width")) {
      t.backgroundWidth = this.backgroundWidth();
    }
    if (fieldSet.has("background_height")) {
      t.backgroundHeight = this.backgroundHeight();
    }
    if (fieldSet.has("display_name")) {
      t.displayName = this.displayName();
    }
    if (fieldSet.has("font_size")) {
      t.fontSize = this.fontSize();
    }
    if (fieldSet.has("font_color_hex")) {
      t.fontColorHex = this.fontColorHex();
    }
    if (fieldSet.has("background_rotation_deg")) {
      t.backgroundRotationDeg = this.backgroundRotationDeg();
    }
    if (fieldSet.has("name_rotation_deg")) {
      t.nameRotationDeg = this.nameRotationDeg();
    }
    if (fieldSet.has("sync_rotations")) {
      t.syncRotations = this.syncRotations();
    }
    if (fieldSet.has("min_x")) {
      t.minX = this.minX();
    }
    if (fieldSet.has("max_x")) {
      t.maxX = this.maxX();
    }
    if (fieldSet.has("min_y")) {
      t.minY = this.minY();
    }
    if (fieldSet.has("max_y")) {
      t.maxY = this.maxY();
    }
    if (fieldSet.has("lifts")) {
      t.lifts = this.bb!.createObjList<Waypoint, WaypointT>(
        this.lifts.bind(this),
        this.liftsLength(),
      );
    }
    if (fieldSet.has("banks")) {
      t.banks = this.bb!.createObjList<BankWaypoint, BankWaypointT>(
        this.banks.bind(this),
        this.banksLength(),
      );
    }
    return t;
  }
}

export class GroupWaypointT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public nickname: string | Uint8Array | null = null,
    public x: number = 0.0,
    public y: number = 0.0,
    public backgroundColorHex: string | Uint8Array | null = null,
    public backgroundOpacity: number = 0,
    public backgroundWidth: number = 0,
    public backgroundHeight: number = 0,
    public displayName: boolean = false,
    public fontSize: number = 0,
    public fontColorHex: string | Uint8Array | null = null,
    public backgroundRotationDeg: number = 0,
    public nameRotationDeg: number = 0,
    public syncRotations: boolean = true,
    public minX: number = 0.0,
    public maxX: number = 0.0,
    public minY: number = 0.0,
    public maxY: number = 0.0,
    public lifts: WaypointT[] = [],
    public banks: BankWaypointT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const nickname = this.nickname !== null ? builder.createString(this.nickname!) : 0;
    const backgroundColorHex =
      this.backgroundColorHex !== null ? builder.createString(this.backgroundColorHex!) : 0;
    const fontColorHex = this.fontColorHex !== null ? builder.createString(this.fontColorHex!) : 0;
    const lifts = GroupWaypoint.createLiftsVector(
      builder,
      builder.createObjectOffsetList(this.lifts),
    );
    const banks = GroupWaypoint.createBanksVector(
      builder,
      builder.createObjectOffsetList(this.banks),
    );

    return GroupWaypoint.createGroupWaypoint(
      builder,
      id,
      nickname,
      this.x,
      this.y,
      backgroundColorHex,
      this.backgroundOpacity,
      this.backgroundWidth,
      this.backgroundHeight,
      this.displayName,
      this.fontSize,
      fontColorHex,
      this.backgroundRotationDeg,
      this.nameRotationDeg,
      this.syncRotations,
      this.minX,
      this.maxX,
      this.minY,
      this.maxY,
      lifts,
      banks,
    );
  }

  clone(): GroupWaypointT {
    const obj = new GroupWaypointT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.nickname = this.nickname;
    obj.x = this.x;
    obj.y = this.y;
    obj.backgroundColorHex = this.backgroundColorHex;
    obj.backgroundOpacity = this.backgroundOpacity;
    obj.backgroundWidth = this.backgroundWidth;
    obj.backgroundHeight = this.backgroundHeight;
    obj.displayName = this.displayName;
    obj.fontSize = this.fontSize;
    obj.fontColorHex = this.fontColorHex;
    obj.backgroundRotationDeg = this.backgroundRotationDeg;
    obj.nameRotationDeg = this.nameRotationDeg;
    obj.syncRotations = this.syncRotations;
    obj.minX = this.minX;
    obj.maxX = this.maxX;
    obj.minY = this.minY;
    obj.maxY = this.maxY;
    obj.lifts = this.lifts.map((e) => e.clone());
    obj.banks = this.banks.map((e) => e.clone());
    return obj;
  }

  equals(other: GroupWaypointT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.nickname !== other.nickname) return false;
    if (!Object.is(this.x, other.x)) return false;
    if (!Object.is(this.y, other.y)) return false;
    if (this.backgroundColorHex !== other.backgroundColorHex) return false;
    if (this.backgroundOpacity !== other.backgroundOpacity) return false;
    if (this.backgroundWidth !== other.backgroundWidth) return false;
    if (this.backgroundHeight !== other.backgroundHeight) return false;
    if (this.displayName !== other.displayName) return false;
    if (this.fontSize !== other.fontSize) return false;
    if (this.fontColorHex !== other.fontColorHex) return false;
    if (this.backgroundRotationDeg !== other.backgroundRotationDeg) return false;
    if (this.nameRotationDeg !== other.nameRotationDeg) return false;
    if (this.syncRotations !== other.syncRotations) return false;
    if (!Object.is(this.minX, other.minX)) return false;
    if (!Object.is(this.maxX, other.maxX)) return false;
    if (!Object.is(this.minY, other.minY)) return false;
    if (!Object.is(this.maxY, other.maxY)) return false;
    if (this.lifts.length !== other.lifts.length) return false;
    for (let i = 0; i < this.lifts.length; i++) {
      const a = this.lifts[i];
      const b = other.lifts[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.banks.length !== other.banks.length) return false;
    for (let i = 0; i < this.banks.length; i++) {
      const a = this.banks[i];
      const b = other.banks[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyGroupWaypoint(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 8);
    verifier.checkScalarField(tablePos, 10, 8);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 4);
    verifier.checkScalarField(tablePos, 18, 4);
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 26, 4);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 1);
    verifier.checkScalarField(tablePos, 32, 8);
    verifier.checkScalarField(tablePos, 34, 8);
    verifier.checkScalarField(tablePos, 36, 8);
    verifier.checkScalarField(tablePos, 38, 8);
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyWaypoint);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyBankWaypoint);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
